import { fetchUtils, HttpError, type Identifier } from 'react-admin';
import {
  createReactAdminValidationError,
  getJsonApiErrorBody,
  getJsonApiErrorMessage,
  getJsonApiErrorStatus,
} from '../JsonApiTypes';
import { defaultHeaders } from '../utils';

export interface MappingRuleCategoryBulkRemapResponse {
  mappingRulesUpdated: number;
  offerRowsUpdated: number;
}

export interface MappingRuleCategoryBulkRemapParams {
  mappingRuleIds: Identifier[];
  toCategoryId: number;
  mappingRuleIdsToUpdateOffers: number[];
}

export type MappingRuleCategoryBulkRemap = (
  params: MappingRuleCategoryBulkRemapParams,
) => Promise<MappingRuleCategoryBulkRemapResponse>;

export default function mappingRuleCategoryBulkRemap(
  apiUrl: string,
  httpClient = fetchUtils.fetchJson,
): MappingRuleCategoryBulkRemap {
  return async ({ mappingRuleIds, toCategoryId, mappingRuleIdsToUpdateOffers }) => {
    try {
      const response = await httpClient(`${apiUrl}/mapping-rules/bulk-remap-category`, {
        method: 'POST',
        headers: defaultHeaders,
        body: JSON.stringify({
          mappingRuleIds: mappingRuleIds.map(Number),
          toCategoryId,
          mappingRuleIdsToUpdateOffers:
            mappingRuleIdsToUpdateOffers.length > 0 ? mappingRuleIdsToUpdateOffers : undefined,
        }),
      });

      return (response.json ?? {}) as MappingRuleCategoryBulkRemapResponse;
    } catch (error) {
      const validationErrors = createReactAdminValidationError(error as HttpError);
      throw new HttpError(
        getJsonApiErrorMessage(error as HttpError, 'Error bulk remapping mapping rules'),
        getJsonApiErrorStatus(error as HttpError),
        { ...validationErrors, apiResponse: getJsonApiErrorBody(error) },
      );
    }
  };
}
